var _templateObject;

function _extends() {
  _extends = Object.assign
    ? Object.assign.bind()
    : function (target) {
        for (var i = 1; i < arguments.length; i++) {
          var source = arguments[i];
          for (var key in source) {
            if (Object.prototype.hasOwnProperty.call(source, key)) {
              target[key] = source[key];
            }
          }
        }
        return target;
      };
  return _extends.apply(this, arguments);
}

function _taggedTemplateLiteralLoose(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }
  strings.raw = raw;
  return strings;
}

import { Box, Button, ResponsiveContext, Text } from "grommet";
import React, { useContext, useEffect } from "react";
import { isMobileTabletResponsive } from "../../../utils/utils";
import { PasswordInput } from "../../Inputs/PasswordInput";
import { TextInput } from "../../Inputs/TextInput";
import { routes } from "../../../const/routes";
import { useForm, Controller } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { makeValidationSchema } from "../makeValidationSchema";
import { PopupWithButton } from "../../Popups/PopupWithButton";
import styled from "styled-components";
var LinkWrapper = styled.a(
  _templateObject || (_templateObject = _taggedTemplateLiteralLoose([""]))
);
export var SignUpForm = function SignUpForm(_ref) {
  var isSendedMail = _ref.isSendedMail,
    authError = _ref.authError,
    setAuthError = _ref.setAuthError,
    setSendMail = _ref.setSendMail,
    registration = _ref.registration,
    as = _ref.as;
  var validateForm = makeValidationSchema();

  var _useForm = useForm({
      resolver: yupResolver(validateForm),
      shouldFocusError: false,
    }),
    handleSubmit = _useForm.handleSubmit,
    control = _useForm.control,
    errors = _useForm.formState.errors,
    clearErrors = _useForm.clearErrors,
    setValue = _useForm.setValue;

  var size = useContext(ResponsiveContext);
  var isMobileWidth = isMobileTabletResponsive(size);
  useEffect(function () {
    return function () {
      setAuthError("");
      setSendMail(false);
    };
  }, []);

  var sendedMailHandler = function sendedMailHandler() {
    setSendMail(false);
    window.location.href = routes.main.path;
  };

  var onSubmit = function onSubmit(data) {
    return registration(data);
  };

  return /*#__PURE__*/ React.createElement(
    "form",
    {
      onSubmit: handleSubmit(onSubmit),
    },
    /*#__PURE__*/ React.createElement(
      Box,
      {
        background: {
          color: "site-colors-1",
        },
        round: "small",
        pad: isMobileWidth
          ? {
              top: "26px",
              bottom: "45px",
              horizontal: "20px",
            }
          : {
              top: "30px",
              bottom: "40px",
              horizontal: "45px",
            },
      },
      /*#__PURE__*/ React.createElement(
        Box,
        {
          flex: true,
          direction: "column",
        },
        /*#__PURE__*/ React.createElement(
          Box,
          {
            flex: true,
            direction: isMobileWidth ? "column" : "row",
            gap: isMobileWidth ? "2rem" : "4rem",
          },
          /*#__PURE__*/ React.createElement(Controller, {
            name: "email",
            control: control,
            render: function render(_ref2) {
              var _errors$email;

              var field = _ref2.field;
              return /*#__PURE__*/ React.createElement(
                TextInput,
                _extends(
                  {
                    error: (_errors$email = errors.email) == null ? void 0 : _errors$email.message,
                    handleFocus: function handleFocus() {
                      return clearErrors("email");
                    },
                    name: "email",
                    id: "signUp-email",
                    handleChange: function handleChange(e) {
                      return setValue(e.target.value);
                    },
                    label: "\u0412\u0432\u0435\u0434\u0438\u0442\u0435 \u0432\u0430\u0448 email",
                    placeholder: "\u0412\u0430\u0448 email",
                  },
                  field
                )
              );
            },
          }),
          /*#__PURE__*/ React.createElement(Controller, {
            name: "password",
            control: control,
            render: function render(_ref3) {
              var _errors$password;

              var field = _ref3.field;
              return /*#__PURE__*/ React.createElement(
                PasswordInput,
                _extends({}, field, {
                  error:
                    (_errors$password = errors.password) == null
                      ? void 0
                      : _errors$password.message,
                  onFocus: function onFocus() {
                    return clearErrors("password");
                  },
                  name: "password",
                  id: "signUp-password",
                  label:
                    "\u0412\u0432\u0435\u0434\u0438\u0442\u0435 \u0432\u0430\u0448 \u043F\u0430\u0440\u043E\u043B\u044C",
                  placeholder: "\u0412\u0430\u0448 \u043F\u0430\u0440\u043E\u043B\u044C",
                })
              );
            },
          })
        ),
        /*#__PURE__*/ React.createElement(
          Box,
          {
            flex: true,
            direction: "column",
          },
          /*#__PURE__*/ React.createElement(
            Box,
            {
              flex: true,
              align: "center",
              height: "56px",
              width: {
                max: "406px",
              },
              margin: {
                top: "2rem",
              },
              pad: {
                vertical: "1rem",
              },
              style: {
                borderRadius: "5px",
                backgroundColor: "black",
                color: "#F8F8F8",
                cursor: "pointer",
              },
            },
            /*#__PURE__*/ React.createElement(
              Button,
              {
                type: "submit",
              },
              "\u0417\u0430\u0440\u0435\u0433\u0438\u0441\u0442\u0440\u0438\u0440\u043E\u0432\u0430\u0442\u044C\u0441\u044F"
            )
          ),
          /*#__PURE__*/ React.createElement(
            Box,
            {
              flex: true,
              direction: "row",
              gap: "1rem",
              align: "center",
              margin: {
                top: "1.5rem",
              },
            },
            /*#__PURE__*/ React.createElement(
              Text,
              {
                style: {
                  lineHeight: "22px",
                  fontStyle: "italic",
                  color: "black",
                },
                size: "small",
                color: "black",
              },
              "\u0423\u0436\u0435 \u0435\u0441\u0442\u044C \u0430\u043A\u043A\u0430\u0443\u043D\u0442?"
            ),
            /*#__PURE__*/ React.createElement(
              LinkWrapper,
              {
                as: as,
                to: routes.signIn.path,
              },
              /*#__PURE__*/ React.createElement(
                Text,
                {
                  style: {
                    lineHeight: "22px",
                    fontStyle: "italic",
                    color: "black",
                  },
                  size: "small",
                  color: "black",
                },
                "\u0412\u043E\u0439\u0442\u0438"
              )
            )
          ),
          isSendedMail
            ? /*#__PURE__*/ React.createElement(PopupWithButton, {
                subtext: "Проверьте почту!",
                paragraph:
                  "Для подтверждения перейдите по ссылке, указанной в письме (письмо может быть в спаме)",
                closePopup: sendedMailHandler,
                button:
                  "\u041D\u0430\u0437\u0430\u0434 \u043D\u0430 \u0433\u043B\u0430\u0432\u043D\u0443\u044E",
              })
            : null,
          authError.length
            ? /*#__PURE__*/ React.createElement(PopupWithButton, {
                paragraph: authError,
                subtext: "Ошибка регистрации",
                closePopup: function closePopup() {
                  return setAuthError("");
                },
                button:
                  "\u0412\u0435\u0440\u043D\u0443\u0442\u044C\u0441\u044F \u043A \u0440\u0435\u0433\u0438\u0441\u0442\u0440\u0430\u0446\u0438\u0438",
              })
            : null
        )
      )
    )
  );
};
